import { Theme, lighten } from "@mui/material/styles";
import { stickyColumnSx, STICKY_BODY_Z_INDEX } from "../SaleDepositReport/tableLayout";

// Column geometry and tints shared by the header, the category rows and the line rows: they
// all render inside ONE <Table>, so the two pinned columns must sit at the same offsets.

/** สินค้า and รายการ stay pinned while the 28–31 day columns scroll past them. */
export const PRODUCT_COLUMN_WIDTH = 200;
export const LINE_COLUMN_WIDTH = 80;
/** Wide enough for "12,345" and "100.00%" at the table's small size. */
const DAY_COLUMN_MIN_WIDTH = 56;

/** The table scrolls inside the page so its day header stays in view down a long month. */
const TABLE_MAX_HEIGHT = "70vh";

export const tableContainerSx = { maxHeight: TABLE_MAX_HEIGHT } as const;

/** How far toward white the theme's error colour is lifted to tint a Sunday column. */
const SUNDAY_TINT_COEFFICIENT = 0.88;

export const productColumnSx = {
  ...stickyColumnSx(0, STICKY_BODY_Z_INDEX),
  width: PRODUCT_COLUMN_WIDTH,
  minWidth: PRODUCT_COLUMN_WIDTH,
  maxWidth: PRODUCT_COLUMN_WIDTH,
  verticalAlign: "top",
  whiteSpace: "normal",
} as const;

export const lineColumnSx = {
  ...stickyColumnSx(PRODUCT_COLUMN_WIDTH, STICKY_BODY_Z_INDEX),
  width: LINE_COLUMN_WIDTH,
  minWidth: LINE_COLUMN_WIDTH,
  whiteSpace: "nowrap",
} as const;

/** A หมวด heading spans both pinned columns and stays in view with them. */
export const categoryColumnSx = {
  ...stickyColumnSx(0, STICKY_BODY_Z_INDEX),
  whiteSpace: "nowrap",
} as const;

export const dayColumnSx = {
  minWidth: DAY_COLUMN_MIN_WIDTH,
  whiteSpace: "nowrap",
  fontVariantNumeric: "tabular-nums",
} as const;

/** Opaque, so a pinned header cell or a sticky header row never shows the rows behind it. */
export const sundayCellSx = {
  bgcolor: (theme: Theme) => lighten(theme.palette.error.main, SUNDAY_TINT_COEFFICIENT),
} as const;

export const totalColumnSx = { ...dayColumnSx, fontWeight: 600 } as const;
